<template>
  <div class="wrapper">
    <div class="contentContainer">
      <div class="contentContainer--body">
        <slot 				
          :historyImageModalId="historyImageModalId"
          :retrainModalId="retrainModalId"
        > 
        </slot>
      </div>
      <div class="contentContainer--footer">
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import Footer from "@/components/shared/Footer/Footer.vue";
const globalMapper = createNamespacedHelpers('global');
import { createNamespacedHelpers } from "vuex";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      myCallbacks: {
        onSkip: () => {
          this.isChangeStat = true;
        },
        onFinish: () => {
          this.isChangeStat = true;
        },
      },
      isChangeStat: true,
      height: document.documentElement.clientHeight,
      width: document.documentElement.clientWidth,

      myOptions: {
        useKeyboardNavigation: false,
        highlight: true,
      },
    };
  },
  props: {
		historyImageModalId: {
      type: String,
      default: "ModalIdfromApp",
		},
		retrainModalId: {
      type: String,
      default: "ModalIdfromRetrainModal",
		},
	},
  mounted() {
    window.addEventListener("resize", this.onScreenResize);
    this.setIndicator("showTrainer")
    this.SET_NAME_PAGE('expresstrainerAppName')
  },
  computed: {
    steps() {
      return [
        {
          target: ".trainer-step-0",
          content: `Choosing the type of image after taking a photo`,
          params: {
            placement: "left",
          },
          before: (type) =>
            new Promise((resolve, reject) => {
              this.$router.push("/trainer");
              resolve("foo");
            }),
        },
        {
          target: ".trainer-step-1",
          header: {
            title: `Interval capture`,
          },
          content: "The app will automatically take a photo after 10 seconds",
          params: {
            placement: "left",
          },
        },
        {
          target: ".trainer-step-2",
          header: {
            title: `Front camera`,
          },
          content: "Toggle button to switch between front and back camera",
          params: {
            placement: "left",
          },
        },
        {
          target: ".trainer-step-3",
          content: "Click to switch between different models",
          before: (type) =>
            new Promise((resolve, reject) => {
              this.$bvModal.hide("modal-1");
              resolve("foo");
            }),
        },
        {
          target: ".trainer-step-4",
          header: {
            title: `select the model`,
          },
          content: "Swipe or press a button to switch between different models",
          params: {
            placement: "bottom",
          },
          before: (type) =>
            new Promise((resolve, reject) => {
              this.$bvModal.show("modal-1");
              resolve("foo");
            }),
        },
        {
          target: ".trainer-step-5",
          header: {
            title: `Click on the capture button`,
          },
          content:
            "After taking a photo, it will be processed and displayed in the image list on the right side",
          before: (type) =>
            new Promise((resolve, reject) => {
              this.$bvModal.hide("modal-1");
              resolve("foo");
            }),
        },
        {
          target: '[data-trainer-step="6"]',
          content: "List of processed images",
          before: (type) =>
            new Promise((resolve, reject) => {
              this.$bvModal.hide("modal-1");
              resolve("foo");
            }),
        },
      ];
    },
  },
  methods: {
    ...globalMapper.mapActions([
      "setIndicator",
    ]),
    ...globalMapper.mapMutations([
      "SET_NAME_PAGE"

    ]),
    onScreenResize() {
      this.height = document.documentElement.clientHeight;
      this.width = document.documentElement.clientWidth;
    },
    onStartTour() {
      this.isChangeStat = false;
      this.$tours["trainerTour"].start();
    },
  },
};
</script>
